<div class="row w-100 m-0 p-0 shadow-sm">
    <div class="col-12 position-relative p-0">
        <div class="mobile-size">
            <img  class="banner-img" src="../../../assets/img/Rectangle.png" alt="">
        </div>
        <div class="trapezoid">
            <div class="row h-100 font-white justify-content-end pe-sm-5 pe-md-0 m-0 justify-content-md-center">
                <img class="position-absolute top-0 end-0 corner-img m-0 p-0" src="../../../assets/img/Layer_1.png" alt="">
                <div class="col-11 col-md-8 col-lg-10 px-4 pe-sm-1 ps-lg-3 my-5 d-flex flex-column  justify-content-around aling-items-baseline text-center">
                    <p class="text-center banner-title"> {{ 'BANNER.LABEL1' | translate }} </p>
                    <div class="row p-0 m-0 justify-content-center">
                        <div class="col-12 col-lg-11 col-xxl-9 col-xl-10 m-0 p-0">
                            <p class="text-center banner-description"> {{ 'BANNER.LABEL2' | translate }} </p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button class="btn-banner d-block"> {{ 'BANNER.LABEL3' | translate }} </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>